import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=ac4d0fca"
import script from "./Share.vue?vue&type=script&lang=ts"
export * from "./Share.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports